// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.conteudo {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap; /* Isso garante que as seções desçam se apertar */
  background: #FBFBFB;
  min-height: 400px;
  height: auto;
  width: 100%;
  box-sizing: border-box;
  padding: 24px 16px;
  /* --- 1. UPLOAD CARD --- */
  /* --- 2. BOTÃO BAIXAR TODOS --- */
  /* --- 3. BLOCOS DE CONTEÚDO (Galeria e Texto) --- */
  /* --- 4. GALERIA --- */
  /* Ajuste nos botões laterais para não serem esmagados */
  /* --- 5. ARQUIVOS DE TEXTO --- */
}
@media (min-width: 1025px) {
  .conteudo {
    padding-top: 60px;
  }
}
.conteudo .upload-card {
  flex: 1;
  min-width: 280px;
  max-width: 350px;
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  box-shadow: none !important;
  background-color: transparent;
  cursor: pointer;
  transition: background 0.2s;
}
.conteudo .upload-card:hover {
  background-color: rgba(0, 0, 0, 0.02);
  border-color: #999;
}
.conteudo .upload-card .upload-content {
  text-align: center;
}
.conteudo .upload-card .upload-content img {
  width: 48px;
  margin-bottom: 12px;
  opacity: 0.6;
}
.conteudo .upload-card .upload-content p {
  color: #666;
  font-weight: 500;
  margin: 0;
}
@media (max-width: 1024px) {
  .conteudo .upload-card {
    flex: 0 0 100%;
    max-width: 100%;
    height: 180px;
    order: -1;
  }
}
.conteudo .acoes-extras .btn-baixar-todos {
  color: #D32F2F;
  font-weight: 600;
  text-transform: none;
}
.conteudo .acoes-extras .btn-baixar-todos mat-icon {
  margin-right: 4px;
}
.conteudo .acoes-extras .btn-baixar-todos:hover {
  background-color: rgba(211, 47, 47, 0.04);
}
@media (min-width: 1025px) {
  .conteudo .acoes-extras {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 10;
  }
}
@media (max-width: 1024px) {
  .conteudo .acoes-extras {
    position: static;
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 16px;
    order: 10;
  }
}
.conteudo .galeria,
.conteudo .arquivos-texto {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  /* ALTERADO: Aumentei o max-width para caber 4 imagens + botões */
  /* Antes era 500px, agora 650px dá folga para 4 imagens de ~80px + gaps + setas */
  max-width: 650px;
  min-width: 300px;
}
@media (max-width: 1024px) {
  .conteudo .galeria,
  .conteudo .arquivos-texto {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: auto;
  }
}
.conteudo .galeria p,
.conteudo .arquivos-texto p {
  font-size: 16px;
  margin: 0px;
  text-align: center;
  margin-bottom: 16px;
  font-weight: 500;
}
.conteudo .galeria {
  /* Garante que a galeria tenha largura suficiente para 4 itens */
  /* Ajustei para min-content para que as setas fiquem coladas no grid */
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
  /* --- O NOVO GRID MÁGICO --- */
  /* --- RESPONSIVIDADE DO GRID --- */
  /* Quando a tela for muito pequena (celular em pé), cai para 2 colunas */
}
.conteudo .galeria .photos {
  display: flex;
  align-items: center; /* Centraliza verticalmente as setas com o grid */
  justify-content: center;
  gap: 8px;
}
.conteudo .galeria .grid-imagens {
  display: grid;
  /* FORÇA 4 COLUNAS DE TAMANHO IGUAL */
  grid-template-columns: repeat(4, 1fr);
  /* Espaçamento entre as fotos */
  gap: 8px;
  /* Centraliza o grid dentro da área disponível */
  margin: 0 auto;
  /* Limita a largura das imagens para não estourar em telas pequenas */
  max-width: 100%;
}
.conteudo .galeria .grid-imagens .imagem-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
}
.conteudo .galeria .grid-imagens .imagem-wrapper .img-default {
  /* Tamanho fixo para padronizar */
  width: 70px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: white;
}
.conteudo .galeria .grid-imagens .imagem-wrapper .icone-acao {
  position: absolute;
  bottom: 5px;
  right: 5px; /* Ajuste se a imagem for muito pequena */
  width: 20px;
  height: 20px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  padding: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s;
}
.conteudo .galeria .grid-imagens .imagem-wrapper .icone-acao:hover {
  transform: scale(1.1);
}
@media (max-width: 480px) {
  .conteudo .galeria .grid-imagens {
    grid-template-columns: repeat(2, 1fr);
  }
}
.conteudo button.mat-icon-button {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.conteudo button.mat-icon-button mat-icon {
  font-size: 20px;
}
.conteudo .arquivos-texto {
  /* Mantido igual, mas ajusta-se ao flex-wrap do pai */
}
.conteudo .arquivos-texto .files {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}
.conteudo .arquivos-texto .file-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 400px;
  min-height: 150px;
  justify-content: flex-start;
}
.conteudo .arquivos-texto .file-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #f9f9f9;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  border: 1px solid transparent;
  transition: all 0.2s;
}
.conteudo .arquivos-texto .file-list li:hover {
  border-color: #ddd;
  background: #f0f0f0;
}
.conteudo .arquivos-texto .file-list li span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}
@media (max-width: 400px) {
  .conteudo .arquivos-texto .file-list li span {
    max-width: 120px;
  }
}
.conteudo .arquivos-texto .file-list li img:first-child {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.conteudo .arquivos-texto .file-list li img:last-child {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.conteudo .reiniciar {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  order: 20;
}
.conteudo .reiniciar a {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #D32F2F;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
}
.conteudo .reiniciar a:hover {
  text-decoration: underline;
}
.conteudo .reiniciar a img {
  width: 16px;
}
.conteudo button.mat-icon-button {
  flex-shrink: 0;
}
.conteudo .icon-left {
  order: -1;
}
.conteudo .icon-right {
  order: 1;
}
.conteudo .no-files {
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 600px) {
  mat-panel-title h1 {
    font-size: 16px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/file-manager/file-manager.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA,EAAA,iDAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EAMA,2BAAA;EA6CA,kCAAA;EA2BA,oDAAA;EA4BA,uBAAA;EAyEF,wDAAA;EAYE,iCAAA;AAvLF;AANE;EAdF;IAeI,iBAAA;EASF;AACF;AANE;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,eAAA;EACA,2BAAA;AAMJ;AAJI;EACE,qCAAA;EACA,kBAAA;AAMN;AAHI;EACE,kBAAA;AAKN;AAJM;EACE,WAAA;EACA,mBAAA;EACA,YAAA;AAMR;AAJM;EACE,WAAA;EACA,gBAAA;EACA,SAAA;AAMR;AAFI;EApCF;IAqCI,cAAA;IACA,eAAA;IACA,aAAA;IACA,SAAA;EAKJ;AACF;AAAI;EACE,cAAA;EACA,gBAAA;EACA,oBAAA;AAEN;AADM;EAAW,iBAAA;AAIjB;AAHM;EAAU,yCAAA;AAMhB;AAHI;EATF;IAUI,kBAAA;IACA,SAAA;IACA,WAAA;IACA,WAAA;EAMJ;AACF;AAJI;EAhBF;IAiBI,gBAAA;IACA,WAAA;IACA,aAAA;IACA,uBAAA;IACA,gBAAA;IACA,SAAA;EAOJ;AACF;AAHE;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;EAEA,iEAAA;EACA,iFAAA;EACA,gBAAA;EACA,gBAAA;AAIJ;AAFI;EAZF;;IAaI,cAAA;IACA,eAAA;IACA,eAAA;EAMJ;AACF;AAJI;;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAON;AAFA;EACE,gEAAA;EACA,sEAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EASA,+BAAA;EAkDA,mCAAA;EACA,wEAAA;AArDF;AALE;EACE,aAAA;EACA,mBAAA,EAAA,iDAAA;EACA,uBAAA;EACA,QAAA;AAOJ;AAHE;EACE,aAAA;EACA,qCAAA;EACA,qCAAA;EAEA,+BAAA;EACA,QAAA;EAEA,gDAAA;EACA,cAAA;EAEA,qEAAA;EACA,eAAA;AAEJ;AAAI;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAEN;AAAM;EACE,iCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AAER;AACM;EACE,kBAAA;EACA,WAAA;EACA,UAAA,EAAA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,0BAAA;AACR;AACQ;EACE,qBAAA;AACV;AAOE;EACE;IACE,qCAAA;EALJ;AACF;AAUA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AARF;AAUE;EACE,eAAA;AARJ;AAaE;EACE,qDAAA;AAXJ;AAYI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;AAVN;AAaI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAXN;AAaM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,6BAAA;EACA,oBAAA;AAXR;AAaQ;EACE,kBAAA;EACA,mBAAA;AAXV;AAcQ;EACG,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAZX;AAaW;EALH;IAK+B,gBAAA;EATrC;AACF;AAWQ;EAAkB,WAAA;EAAa,YAAA;EAAc,cAAA;AANrD;AAOQ;EAAiB,WAAA;EAAa,YAAA;EAAc,cAAA;AAFpD;AAOE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AALJ;AAOI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AALN;AAMM;EAAU,0BAAA;AAHhB;AAIM;EAAM,WAAA;AADZ;AAKE;EAAyB,cAAA;AAF3B;AAGE;EAAa,SAAA;AAAf;AACE;EAAc,QAAA;AAEhB;AADE;EACG,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAGL;;AACA;EAEI;IACE,0BAAA;EACJ;AACF","sourcesContent":[".conteudo {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 24px;\n  flex-wrap: wrap; /* Isso garante que as seções desçam se apertar */\n  background: #FBFBFB;\n  min-height: 400px;\n  height: auto;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 24px 16px;\n\n  @media (min-width: 1025px) {\n    padding-top: 60px;\n  }\n\n  /* --- 1. UPLOAD CARD --- */\n  .upload-card {\n    flex: 1;\n    min-width: 280px;\n    max-width: 350px;\n    height: 220px;\n    \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    \n    border: 2px dashed #ccc;\n    box-shadow: none !important;\n    background-color: transparent;\n    cursor: pointer;\n    transition: background 0.2s;\n\n    &:hover {\n      background-color: rgba(0,0,0,0.02);\n      border-color: #999;\n    }\n\n    .upload-content {\n      text-align: center;\n      img {\n        width: 48px;\n        margin-bottom: 12px;\n        opacity: 0.6;\n      }\n      p {\n        color: #666;\n        font-weight: 500;\n        margin: 0;\n      }\n    }\n\n    @media (max-width: 1024px) {\n      flex: 0 0 100%;\n      max-width: 100%;\n      height: 180px;\n      order: -1;\n    }\n  }\n\n  /* --- 2. BOTÃO BAIXAR TODOS --- */\n  .acoes-extras {\n    .btn-baixar-todos {\n      color: #D32F2F;\n      font-weight: 600;\n      text-transform: none;\n      mat-icon { margin-right: 4px; }\n      &:hover { background-color: rgba(211, 47, 47, 0.04); }\n    }\n\n    @media (min-width: 1025px) {\n      position: absolute;\n      top: 16px;\n      right: 16px;\n      z-index: 10;\n    }\n\n    @media (max-width: 1024px) {\n      position: static;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      margin-top: 16px;\n      order: 10;\n    }\n  }\n\n  /* --- 3. BLOCOS DE CONTEÚDO (Galeria e Texto) --- */\n  .galeria,\n  .arquivos-texto {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1;\n    \n    /* ALTERADO: Aumentei o max-width para caber 4 imagens + botões */\n    /* Antes era 500px, agora 650px dá folga para 4 imagens de ~80px + gaps + setas */\n    max-width: 650px; \n    min-width: 300px; \n\n    @media (max-width: 1024px) {\n      flex: 0 0 100%;\n      max-width: 100%;\n      min-width: auto;\n    }\n\n    p {\n      font-size: 16px;\n      margin: 0px;\n      text-align: center;\n      margin-bottom: 16px;\n      font-weight: 500;\n    }\n  }\n\n  /* --- 4. GALERIA --- */\n.galeria {\n  /* Garante que a galeria tenha largura suficiente para 4 itens */\n  /* Ajustei para min-content para que as setas fiquem coladas no grid */\n  width: fit-content; \n  max-width: 100%; \n\n  .photos {\n    display: flex;\n    align-items: center; /* Centraliza verticalmente as setas com o grid */\n    justify-content: center;\n    gap: 8px;\n  }\n\n  /* --- O NOVO GRID MÁGICO --- */\n  .grid-imagens {\n    display: grid;\n    /* FORÇA 4 COLUNAS DE TAMANHO IGUAL */\n    grid-template-columns: repeat(4, 1fr); \n    \n    /* Espaçamento entre as fotos */\n    gap: 8px; \n    \n    /* Centraliza o grid dentro da área disponível */\n    margin: 0 auto;\n    \n    /* Limita a largura das imagens para não estourar em telas pequenas */\n    max-width: 100%;\n\n    .imagem-wrapper {\n      position: relative;\n      display: flex;\n      justify-content: center;\n      \n      .img-default {\n        /* Tamanho fixo para padronizar */\n        width: 70px; \n        height: 80px;\n        object-fit: cover;\n        border-radius: 4px;\n        border: 1px solid #ccc;\n        background-color: white;\n      }\n\n      .icone-acao {\n        position: absolute;\n        bottom: 5px;\n        right: 5px; /* Ajuste se a imagem for muito pequena */\n        width: 20px;\n        height: 20px;\n        cursor: pointer;\n        background: rgba(255, 255, 255, 0.9);\n        border-radius: 50%;\n        padding: 3px;\n        box-shadow: 0 1px 2px rgba(0,0,0,0.3);\n        transition: transform 0.2s;\n\n        &:hover {\n          transform: scale(1.1);\n        }\n      }\n    }\n  }\n\n  /* --- RESPONSIVIDADE DO GRID --- */\n  /* Quando a tela for muito pequena (celular em pé), cai para 2 colunas */\n  @media (max-width: 480px) {\n    .grid-imagens {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n}\n\n/* Ajuste nos botões laterais para não serem esmagados */\nbutton.mat-icon-button {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  \n  mat-icon {\n    font-size: 20px;\n  }\n}\n\n  /* --- 5. ARQUIVOS DE TEXTO --- */\n  .arquivos-texto {\n    /* Mantido igual, mas ajusta-se ao flex-wrap do pai */\n    .files {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n      width: 100%;\n    }\n\n    .file-list {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      width: 100%;\n      max-width: 400px;\n      min-height: 150px;\n      justify-content: flex-start;\n\n      li {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 12px;\n        background: #f9f9f9;\n        padding: 12px;\n        border-radius: 6px;\n        cursor: pointer;\n        font-size: 14px;\n        color: #333;\n        border: 1px solid transparent;\n        transition: all 0.2s;\n\n        &:hover {\n          border-color: #ddd;\n          background: #f0f0f0;\n        }\n\n        span { \n           white-space: nowrap;\n           overflow: hidden;\n           text-overflow: ellipsis;\n           max-width: 180px;\n           @media (max-width: 400px) { max-width: 120px; }\n        }\n\n        img:first-child { width: 20px; height: 20px; flex-shrink: 0; }\n        img:last-child { width: 18px; height: 18px; flex-shrink: 0; }\n      }\n    }\n  }\n\n  .reiniciar {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n    order: 20;\n\n    a {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      color: #D32F2F;\n      cursor: pointer;\n      font-weight: 500;\n      text-decoration: none;\n      &:hover { text-decoration: underline; }\n      img { width: 16px; }\n    }\n  }\n\n  button.mat-icon-button { flex-shrink: 0; }\n  .icon-left { order: -1; }\n  .icon-right { order: 1; }\n  .no-files{\n     width: 60%;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n  }\n}\n\n@media(max-width:600px){\n  mat-panel-title{\n    h1{\n      font-size: 16px !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
